import { EditorFilter } from "../types";

// // // //

/**
 * removeEditorFilterByID
 * Removes an EditorFilter from the nested filters of a given EditorFilter recursively based on its ID.
 * @function removeEditorFilterByID
 * @param {EditorFilter} filter - The EditorFilter to remove the filter from.
 * @param {string} id - The ID of the filter to remove.
 * @returns {EditorFilter} - The modified EditorFilter with the filter removed.
 */
export function removeEditorFilterByID(
    filter: EditorFilter,
    id: string,
): EditorFilter {
    filter.nested = filter.nested.filter((nestedFilter) => {
        if (nestedFilter.id === id) {
            return false; // Exclude the filter with the matching ID from the nested filters
        } else {
            removeEditorFilterByID(nestedFilter, id); // Recursively remove from nested filters
            return true; // Include the filter in the nested filters
        }
    });

    return filter;
}
